import { cn } from "~/lib/utils";

// // // //

/**
 * VisualizationGrid
 * Renders a grid for displaying multiple visualizations
 */
export function VisualizationGrid(props: {
    children: React.ReactNode;
    className?: string;
}) {
    const { children, className } = props;
    return (
        <div
            className={cn("grid grid-cols-1 lg:grid-cols-12 gap-6", className)}
        >
            {children}
        </div>
    );
}
